import * as React from "react";
import { DesktopPopupModal } from "halifax";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import {
  MonthAndDatePicker,
  MonthAndDatePickerType,
} from "../MonthAndDatePicker";
import { ConnectedDesktopCalendarPicker } from "./container";
import * as textConstants from "./textConstants";
import "./styles.scss";

export interface IDesktopCalendarPickerProps
  extends ConnectedDesktopCalendarPicker {
  open: boolean;
  onClickSubmit?: () => void;
  closePopup: () => void;
}

export const DesktopCalendarPicker = (props: IDesktopCalendarPickerProps) => {
  const {
    open,
    closePopup,
    fromDate,
    untilDate,
    setOpenDatesModal,
    setFromDate,
    setUntilDate,
    onClickSubmit,
  } = props;

  const [from, setFrom] = React.useState<Date | null>(null);
  const [until, setUntil] = React.useState<Date | null>(null);

  React.useEffect(() => {
    setFrom(fromDate);
  }, [fromDate]);

  React.useEffect(() => {
    setUntil(untilDate);
  }, [untilDate]);

  const handleClickDone = () => {
    closePopup();
    setOpenDatesModal(false);
    setFromDate(from);
    setUntilDate(until);
    if (onClickSubmit) onClickSubmit();
  };

  return (
    <>
      {open && (
        <DesktopPopupModal
          open={open}
          onClose={closePopup}
          className={clsx(
            "desktop-calendar-picker-popup-root",
            "hotels-module"
          )}
          contentClassName="desktop-calendar-picker-wrapper"
          invisibleBackdrop={false}
          headerElement={textConstants.DESKTOP_CALENDAR_TITLE}
        >
          <MonthAndDatePicker
            className="b2b"
            viewType={MonthAndDatePickerType.Horizontal}
            from={from}
            until={until}
            setFromDate={(val: Date | null) => {
              setFrom(val);
            }}
            setUntilDate={(val: Date | null) => {
              setUntil(val);
            }}
            header={textConstants.DESKTOP_CALENDAR_TITLE}
            enableEvents={true}
          />
          <Button
            onClick={handleClickDone}
            disabled={!from || !until}
            className="select-dates-button"
            variant="contained"
          >
            {textConstants.DONE_BUTTON_TEXT}
          </Button>
        </DesktopPopupModal>
      )}
    </>
  );
};
